import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

const logoSrc = '/cropped-logo-garantes.png';

export const Logo = (props) => {
  const theme = useTheme();

  return (
    <Box
      component="img"
      src={logoSrc}
      alt="Garantes"
      sx={{
        height: 40,
        width: 'auto',
        display: 'block',
      }}
    />
  );
};

export const LogoFull = (props) => {
  const theme = useTheme();

  return (
    <Box
      component="img"
      src={logoSrc}
      alt="Garantes"
      sx={{
        height: props.height || 32,
        width: 'auto',
        display: 'block',
      }}
    />
  );
};
